import { useState } from "react";
import {
  Grid,
} from "@mui/material";
import { DatePickerField } from "src/components/parts/runner-form/DatePickerField";
import { triggerActionWithResponse } from "src/redux/features/finance-control-tools/actions";
import { AutoDisableButton } from "src/components/parts/AutoDisableButton";
export const RebuildMonthlyReport = () => {
  const today = new Date();
  const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  const [selectedYear, setSelectedYear] = useState<number>(lastMonth.getFullYear());
  const [selectedMonth, setSelectedMonth] = useState<number>(lastMonth.getMonth() + 1);

  return (
    <>
      <h3>Rebuild Monthly Report</h3>
      <p>Rebuild the monthly report cache for a given year and month.</p>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <DatePickerField
            label={'Month'}
            value={new Date(selectedYear, selectedMonth - 1, 1)}
            options={['month', 'year']}
            onChange={(newValue) => {
              if (newValue) {
                setSelectedYear(newValue.getFullYear());
                setSelectedMonth(newValue.getMonth() + 1);
              }
            }}
          />
        </Grid>

        <Grid item xs={8}>
          <AutoDisableButton
            variant="contained"
            onClick={(e) => {
              triggerActionWithResponse('dispatchAction', {
                actionName: 'reportCache',
                parameters: {
                  year: selectedYear,
                  month: selectedMonth,
                },
              });
            }}
          >Rebuild Monthly Report</AutoDisableButton>
        </Grid>
      </Grid>
    </>
  );
};
